__turbopack_context__.v({
  "buttonWrapper": "EmptyTableDisplay-module__L2rdRa__buttonWrapper",
  "emptyTableDisplay": "EmptyTableDisplay-module__L2rdRa__emptyTableDisplay",
  "textWrapper": "EmptyTableDisplay-module__L2rdRa__textWrapper",
});
